import {RefundProfessionalCouncilsParams} from 'domain/usecases';
import {makeGetRefundProfessionalCouncils} from 'main/factories/usecases';

export const getRefundProfessionalCouncils = async (params: RefundProfessionalCouncilsParams) => {
	const data = await makeGetRefundProfessionalCouncils().get(params);

	return data.content.professionalsCouncils;
};
